/**
 * Utility functions for safely handling data from the backend
 */

/**
 * Safely converts an array or string to a comma-separated string
 */
export const safeArrayToString = (value: unknown[] | string | null | undefined, defaultValue: string = ''): string => {
  if (Array.isArray(value)) {
    return value.join(', ');
  }

  if (typeof value === 'string' && value.trim()) {
    return value;
  }

  return defaultValue;
};

/**
 * Safely converts a comma-separated string back to an array
 */
export const safeStringToArray = (value: string | unknown[] | null | undefined): string[] => {
  if (Array.isArray(value)) {
    return value.map(String);
  }

  if (typeof value === 'string' && value.trim()) {
    return value.split(',').map(item => item.trim()).filter(Boolean);
  }

  return [];
};

/**
 * Safely ensures a value is an array (alias for safeStringToArray for backward compatibility)
 */
export const ensureArray = safeStringToArray;
